













import Vue from 'vue';
import PostItem from '@/components/post-item/PostItem.vue';
import PostBlogg from '@/views/post-types/PostBlogg.vue';
import PostProsjekt from '@/views/post-types/PostProsjekt.vue';

export default Vue.extend({
	props: {
		id: Number,
	},
	components: {
		PostItem,
		PostBlogg,
		PostProsjekt,
	},
});
